import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
};

// Ideas
export const ideasAPI = {
  create: (data) => api.post('/ideas', data),
  getAll: (params) => api.get('/ideas', { params }),
  getMy: () => api.get('/ideas/my'),
  getById: (id) => api.get(`/ideas/${id}`),
  generatePlan: (id) => api.post(`/ideas/${id}/generate-plan`),
  upvote: (id) => api.post(`/ideas/${id}/upvote`),
  addMilestone: (id, data) => api.post(`/ideas/${id}/milestones`, data),
  updateMilestone: (ideaId, milestoneId, data) => api.put(`/ideas/${ideaId}/milestones/${milestoneId}`, data),
  exportPdf: (id) => api.get(`/ideas/${id}/export-pdf`, { responseType: 'blob' }),
};

// Comments
export const commentsAPI = {
  create: (data) => api.post('/comments', data),
  getByIdea: (ideaId) => api.get(`/comments/${ideaId}`),
  upvote: (id) => api.post(`/comments/${id}/upvote`),
  accept: (id) => api.post(`/comments/${id}/accept`),
};

// Services
export const servicesAPI = {
  create: (data) => api.post('/services', data),
  getAll: (params) => api.get('/services', { params }),
  getMy: () => api.get('/services/my'),
  purchase: (id, data) => api.post(`/services/${id}/purchase`, data),
  delete: (id) => api.delete(`/services/${id}`),
};

// Collaborations
export const collaborationsAPI = {
  invite: (data) => api.post('/collaborations/invite', data),
  getPending: () => api.get('/collaborations/pending'),
  accept: (id) => api.post(`/collaborations/${id}/accept`),
  decline: (id) => api.post(`/collaborations/${id}/decline`),
};

// Stats & Data
export const statsAPI = {
  getLeaderboard: (limit = 10) => api.get('/leaderboard', { params: { limit } }),
  getTransactions: (limit = 50) => api.get('/transactions', { params: { limit } }),
  getDashboard: () => api.get('/stats/dashboard'),
  getCategories: () => api.get('/categories'),
};

// Orders
export const ordersAPI = {
  getReceived: () => api.get('/orders/received'),
  getPlaced: () => api.get('/orders/placed'),
};

export default api;
